import styled from 'styled-components';
import theme from '../../../../../../theme';

export const StyledTopMargin = styled.div`
    width: 100%;
    margin-top: 35px;
`;

export const StyledOAuthContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 50px;
    @media (max-width: 768px) {
        max-width: 100%;
    }
`;

export const StyledErrorText = styled.span`
    color: ${(p) => p.theme.colors.error};
    margin: 15px 5px;
    font-size: ${(p) => p.theme.fontSizes.label};
`;

export const StyledCheckboxInput = styled.input`
    margin-top: 2px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: ${theme.colors.loopEmerald};
`;

export const StyledCheckboxContainer = styled.div`
    margin-top: 35px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const StyledTypographyWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    flex-wrap: nowrap;
`;

export const StyledTypographySpan = styled.span`
    white-space: nowrap;
`;

